import React from "react";
import { NoAccessInfoMessage } from "../components/alerts/NoAccessInfoMessage.js";
var AccessControlIndicator = /* @__PURE__ */ ((AccessControlIndicator2) => {
  AccessControlIndicator2[AccessControlIndicator2["Hidden"] = 0] = "Hidden";
  AccessControlIndicator2[AccessControlIndicator2["Disabled"] = 1] = "Disabled";
  AccessControlIndicator2[AccessControlIndicator2["InfoMessage"] = 2] = "InfoMessage";
  return AccessControlIndicator2;
})(AccessControlIndicator || {});
function createAccessCheckHOC(useAccessCheck) {
  return function withAccessCheck(WrappedComponent, resource, indicator = 2, message) {
    return function AccessCheck(props) {
      const hasAccess = useAccessCheck(resource);
      function renderNoAccessResult() {
        let result;
        switch (indicator) {
          case 2:
            result = /* @__PURE__ */ React.createElement(NoAccessInfoMessage, { message });
            break;
          case 1:
            result = /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, disabled: true });
            break;
          default:
            result = /* @__PURE__ */ React.createElement(React.Fragment, null);
            break;
        }
        return result;
      }
      return hasAccess ? /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }) : renderNoAccessResult();
    };
  };
}
export {
  AccessControlIndicator,
  createAccessCheckHOC
};
//# sourceMappingURL=AccessCheckHOCFactory.js.map
